// This code is automatically generated by the meta parser, do not modify
// produced with metaParserGenerator.js

let best_failure;
let best_failure_array = [];
let best_failure_index = 0;

// Records parsing failures at the deepest position reached
// Collects all failures at the same position to potentially show "expected: X, Y, or Z"
function record_failure(failure, i) {
  // New deepest position reached - reset tracking
  if (i > best_failure_index) {
    best_failure_array = [];
    best_failure = null;
    best_failure_index = i;
  }
  // Record this failure
  best_failure_array.push(failure);
  // Keep first failure as primary for error messages
  if (!best_failure) {
    best_failure = failure;
  }
}


// Memoization cache for regular rules
// Note: For very large inputs, this cache can grow to O(n * m) where:
// n = input size, m = number of grammar rules
// Cache is cleared between parse() calls to prevent memory leaks
let cache = {};

function memoize(name, func) {
  return function memoize_inner(stream, index) {
    const key = `${name}-${index}`;
    let value = cache[key];
    if (value !== undefined) {
      return value;
    }
    value = func(stream, index);
    cache[key] = value;
    return value;
  };
}

// Separate cache for left-recursive rules
let cacheR = {};

// based on https://medium.com/@gvanrossum_83706/left-recursive-peg-grammars-65dab3c580e1
function memoize_left_recur(name, func) {
  return function memoize_inner(stream, index) {
    const key = `${name}-${index}`;
    let value = cacheR[key];
    if (value !== undefined) {
      return value;
    }
    // prime this rule with a failure
    cacheR[key] = false;
    let lastpos;
    let lastvalue = value;
    while (true) {
      value = func(stream, index);
      if (!value) break;
      if (value.last_index <= lastpos) break;
      lastpos = value.last_index;
      lastvalue = value;
      cacheR[key] = value;
    }
    return lastvalue;
  };
}


let START_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'START',
    sub_rule_index: 0, type: 'START', named,
  };
  const _rule_0 = GLOBAL_STATEMENT(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  let _rule_1 = GLOBAL_STATEMENTS(stream, i);
  while (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
    _rule_1 = GLOBAL_STATEMENTS(stream, i);
  }

  if (stream[i].type !== 'EOS') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'START', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
START_0 = memoize('START_0', START_0);


let START_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'START',
    sub_rule_index: 1, type: 'START', named,
  };
  let _rule_0 = GLOBAL_STATEMENTS(stream, i);
  while (_rule_0) {
    children.push(_rule_0);
    i = _rule_0.last_index;
    _rule_0 = GLOBAL_STATEMENTS(stream, i);
  }

  if (stream[i].type !== 'EOS') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'START', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
START_1 = memoize('START_1', START_1);


let START_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'START',
    sub_rule_index: 2, type: 'START', named,
  };
  const _rule_0 = scomment(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  let _rule_1 = GLOBAL_STATEMENTS(stream, i);
  while (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
    _rule_1 = GLOBAL_STATEMENTS(stream, i);
  }

  if (stream[i].type !== 'EOS') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'START', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
START_2 = memoize('START_2', START_2);


function START(stream, index) {
  return START_0(stream, index)
    || START_1(stream, index)
    || START_2(stream, index);
}
let GLOBAL_STATEMENTS_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENTS',
    sub_rule_index: 0, type: 'GLOBAL_STATEMENTS', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'GLOBAL_STATEMENTS', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = GLOBAL_STATEMENT(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  const _rule_2 = wcomment(stream, i);
  if (_rule_2) {
    children.push(_rule_2);
    i = _rule_2.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENTS_0 = memoize('GLOBAL_STATEMENTS_0', GLOBAL_STATEMENTS_0);


let GLOBAL_STATEMENTS_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENTS',
    sub_rule_index: 1, type: 'GLOBAL_STATEMENTS', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'GLOBAL_STATEMENTS', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = scomment(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENTS_1 = memoize('GLOBAL_STATEMENTS_1', GLOBAL_STATEMENTS_1);


function GLOBAL_STATEMENTS(stream, index) {
  return GLOBAL_STATEMENTS_0(stream, index)
    || GLOBAL_STATEMENTS_1(stream, index);
}
let SCOPED_STATEMENTS_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENTS',
    sub_rule_index: 0, type: 'SCOPED_STATEMENTS', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'SCOPED_STATEMENTS', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_3 = SCOPED_STATEMENT(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = wcomment(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    i = _rule_4.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENTS_0 = memoize('SCOPED_STATEMENTS_0', SCOPED_STATEMENTS_0);


let SCOPED_STATEMENTS_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENTS',
    sub_rule_index: 1, type: 'SCOPED_STATEMENTS', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'SCOPED_STATEMENTS', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_3 = scomment(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    i = _rule_3.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENTS_1 = memoize('SCOPED_STATEMENTS_1', SCOPED_STATEMENTS_1);


function SCOPED_STATEMENTS(stream, index) {
  return SCOPED_STATEMENTS_0(stream, index)
    || SCOPED_STATEMENTS_1(stream, index);
}
let wcomment_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'wcomment',
    sub_rule_index: 0, type: 'wcomment', named,
  };

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'wcomment', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'comment') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'wcomment', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
wcomment_0 = memoize('wcomment_0', wcomment_0);


let wcomment_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'wcomment',
    sub_rule_index: 1, type: 'wcomment', named,
  };

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'wcomment', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'multiline_comment') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'wcomment', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
wcomment_1 = memoize('wcomment_1', wcomment_1);


function wcomment(stream, index) {
  return wcomment_0(stream, index)
    || wcomment_1(stream, index);
}
let scomment_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'scomment',
    sub_rule_index: 0, type: 'scomment', named,
  };

  if (stream[i].type !== 'comment') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'scomment', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
scomment_0 = memoize('scomment_0', scomment_0);


let scomment_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'scomment',
    sub_rule_index: 1, type: 'scomment', named,
  };

  if (stream[i].type !== 'multiline_comment') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'scomment', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
scomment_1 = memoize('scomment_1', scomment_1);


function scomment(stream, index) {
  return scomment_0(stream, index)
    || scomment_1(stream, index);
}
let GLOBAL_STATEMENT_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 0, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = condition(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_0 = memoize('GLOBAL_STATEMENT_0', GLOBAL_STATEMENT_0);


let GLOBAL_STATEMENT_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 1, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = assign(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_1 = memoize('GLOBAL_STATEMENT_1', GLOBAL_STATEMENT_1);


let GLOBAL_STATEMENT_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 2, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = assign_op(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_2 = memoize('GLOBAL_STATEMENT_2', GLOBAL_STATEMENT_2);


let GLOBAL_STATEMENT_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 3, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = virtual_node(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_3 = memoize('GLOBAL_STATEMENT_3', GLOBAL_STATEMENT_3);


let GLOBAL_STATEMENT_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 4, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = class_def(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_4 = memoize('GLOBAL_STATEMENT_4', GLOBAL_STATEMENT_4);


let GLOBAL_STATEMENT_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 5, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = try_catch(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_5 = memoize('GLOBAL_STATEMENT_5', GLOBAL_STATEMENT_5);


let GLOBAL_STATEMENT_6 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 6, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = for_loop(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_6 = memoize('GLOBAL_STATEMENT_6', GLOBAL_STATEMENT_6);


let GLOBAL_STATEMENT_7 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 7, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = while_loop(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_7 = memoize('GLOBAL_STATEMENT_7', GLOBAL_STATEMENT_7);


let GLOBAL_STATEMENT_8 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 8, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = import_statement(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_8 = memoize('GLOBAL_STATEMENT_8', GLOBAL_STATEMENT_8);


let GLOBAL_STATEMENT_9 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 9, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = type_alias(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_9 = memoize('GLOBAL_STATEMENT_9', GLOBAL_STATEMENT_9);


let GLOBAL_STATEMENT_10 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 10, type: 'GLOBAL_STATEMENT', named,
  };
  const _rule_0 = exp_statement(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_10 = memoize('GLOBAL_STATEMENT_10', GLOBAL_STATEMENT_10);


let GLOBAL_STATEMENT_11 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'GLOBAL_STATEMENT',
    sub_rule_index: 11, type: 'GLOBAL_STATEMENT', named,
  };

  if (stream[i].type !== 'throw') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'GLOBAL_STATEMENT', sub_rule_index: 11,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
GLOBAL_STATEMENT_11 = memoize('GLOBAL_STATEMENT_11', GLOBAL_STATEMENT_11);


function GLOBAL_STATEMENT(stream, index) {
  return GLOBAL_STATEMENT_0(stream, index)
    || GLOBAL_STATEMENT_1(stream, index)
    || GLOBAL_STATEMENT_2(stream, index)
    || GLOBAL_STATEMENT_3(stream, index)
    || GLOBAL_STATEMENT_4(stream, index)
    || GLOBAL_STATEMENT_5(stream, index)
    || GLOBAL_STATEMENT_6(stream, index)
    || GLOBAL_STATEMENT_7(stream, index)
    || GLOBAL_STATEMENT_8(stream, index)
    || GLOBAL_STATEMENT_9(stream, index)
    || GLOBAL_STATEMENT_10(stream, index)
    || GLOBAL_STATEMENT_11(stream, index);
}
let exp_statement_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp_statement',
    sub_rule_index: 0, type: 'exp_statement', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
exp_statement_0 = memoize('exp_statement_0', exp_statement_0);


function exp_statement(stream, index) {
  return exp_statement_0(stream, index);
}
let SCOPED_STATEMENT_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 0, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = condition(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_0 = memoize('SCOPED_STATEMENT_0', SCOPED_STATEMENT_0);


let SCOPED_STATEMENT_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 1, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = assign(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_1 = memoize('SCOPED_STATEMENT_1', SCOPED_STATEMENT_1);


let SCOPED_STATEMENT_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 2, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = assign_op(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_2 = memoize('SCOPED_STATEMENT_2', SCOPED_STATEMENT_2);


let SCOPED_STATEMENT_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 3, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = virtual_node(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_3 = memoize('SCOPED_STATEMENT_3', SCOPED_STATEMENT_3);


let SCOPED_STATEMENT_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 4, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = class_def(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_4 = memoize('SCOPED_STATEMENT_4', SCOPED_STATEMENT_4);


let SCOPED_STATEMENT_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 5, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = try_catch(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_5 = memoize('SCOPED_STATEMENT_5', SCOPED_STATEMENT_5);


let SCOPED_STATEMENT_6 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 6, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = for_loop(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_6 = memoize('SCOPED_STATEMENT_6', SCOPED_STATEMENT_6);


let SCOPED_STATEMENT_7 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 7, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = while_loop(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_7 = memoize('SCOPED_STATEMENT_7', SCOPED_STATEMENT_7);


let SCOPED_STATEMENT_8 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 8, type: 'SCOPED_STATEMENT', named,
  };

  if (stream[i].type !== 'return') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'SCOPED_STATEMENT', sub_rule_index: 8,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_8 = memoize('SCOPED_STATEMENT_8', SCOPED_STATEMENT_8);


let SCOPED_STATEMENT_9 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 9, type: 'SCOPED_STATEMENT', named,
  };

  if (stream[i].type !== 'throw') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'SCOPED_STATEMENT', sub_rule_index: 9,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_9 = memoize('SCOPED_STATEMENT_9', SCOPED_STATEMENT_9);


let SCOPED_STATEMENT_10 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 10, type: 'SCOPED_STATEMENT', named,
  };
  const _rule_0 = exp_statement(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_10 = memoize('SCOPED_STATEMENT_10', SCOPED_STATEMENT_10);


let SCOPED_STATEMENT_11 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 11, type: 'SCOPED_STATEMENT', named,
  };

  if (stream[i].type !== 'break') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'SCOPED_STATEMENT', sub_rule_index: 11,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_11 = memoize('SCOPED_STATEMENT_11', SCOPED_STATEMENT_11);


let SCOPED_STATEMENT_12 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'SCOPED_STATEMENT',
    sub_rule_index: 12, type: 'SCOPED_STATEMENT', named,
  };

  if (stream[i].type !== 'continue') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'SCOPED_STATEMENT', sub_rule_index: 12,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
SCOPED_STATEMENT_12 = memoize('SCOPED_STATEMENT_12', SCOPED_STATEMENT_12);


function SCOPED_STATEMENT(stream, index) {
  return SCOPED_STATEMENT_0(stream, index)
    || SCOPED_STATEMENT_1(stream, index)
    || SCOPED_STATEMENT_2(stream, index)
    || SCOPED_STATEMENT_3(stream, index)
    || SCOPED_STATEMENT_4(stream, index)
    || SCOPED_STATEMENT_5(stream, index)
    || SCOPED_STATEMENT_6(stream, index)
    || SCOPED_STATEMENT_7(stream, index)
    || SCOPED_STATEMENT_8(stream, index)
    || SCOPED_STATEMENT_9(stream, index)
    || SCOPED_STATEMENT_10(stream, index)
    || SCOPED_STATEMENT_11(stream, index)
    || SCOPED_STATEMENT_12(stream, index);
}
let assign_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'assign',
    sub_rule_index: 0, type: 'assign', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'explicit_assign') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['explicit_assign'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = exp(stream, i);
  if (!_rule_5) return false;
  named['exp'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
assign_0 = memoize('assign_0', assign_0);


let assign_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'assign',
    sub_rule_index: 1, type: 'assign', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = exp(stream, i);
  if (!_rule_5) return false;
  named['exp'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
assign_1 = memoize('assign_1', assign_1);


let assign_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'assign',
    sub_rule_index: 2, type: 'assign', named,
  };
  const _rule_0 = object_destructuring(stream, i);
  if (!_rule_0) return false;
  named['destructuring'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = exp(stream, i);
  if (!_rule_5) return false;
  named['exp'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
assign_2 = memoize('assign_2', assign_2);


let assign_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'assign',
    sub_rule_index: 3, type: 'assign', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['path'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['exp'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
assign_3 = memoize('assign_3', assign_3);


function assign(stream, index) {
  return assign_0(stream, index)
    || assign_1(stream, index)
    || assign_2(stream, index)
    || assign_3(stream, index);
}
let assign_op_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'assign_op',
    sub_rule_index: 0, type: 'assign_op', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'assign_operator') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = exp(stream, i);
  if (!_rule_5) return false;
  named['exp'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
assign_op_0 = memoize('assign_op_0', assign_op_0);


let assign_op_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'assign_op',
    sub_rule_index: 1, type: 'assign_op', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['target'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'assign_operator') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'assign_op', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['exp'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
assign_op_1 = memoize('assign_op_1', assign_op_1);


function assign_op(stream, index) {
  return assign_op_0(stream, index)
    || assign_op_1(stream, index);
}
let for_loop_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'for_loop',
    sub_rule_index: 0, type: 'for_loop', named,
  };

  if (stream[i].type !== 'for') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['value'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'in') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['in'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['exp'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_7 = SCOPED_STATEMENTS(stream, i);
  while (_rule_7) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_7);
    children.push(_rule_7);
    i = _rule_7.last_index;
    _rule_7 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
for_loop_0 = memoize('for_loop_0', for_loop_0);


let for_loop_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'for_loop',
    sub_rule_index: 1, type: 'for_loop', named,
  };

  if (stream[i].type !== 'for') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['value'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'of') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['of'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['exp'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_7 = SCOPED_STATEMENTS(stream, i);
  while (_rule_7) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_7);
    children.push(_rule_7);
    i = _rule_7.last_index;
    _rule_7 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
for_loop_1 = memoize('for_loop_1', for_loop_1);


let for_loop_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'for_loop',
    sub_rule_index: 2, type: 'for_loop', named,
  };

  if (stream[i].type !== 'for') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['key'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['value'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'in') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_7 = exp(stream, i);
  if (!_rule_7) return false;
  named['exp'] = _rule_7;
  children.push(_rule_7);
  i = _rule_7.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 9,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_10 = SCOPED_STATEMENTS(stream, i);
  while (_rule_10) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_10);
    children.push(_rule_10);
    i = _rule_10.last_index;
    _rule_10 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 11,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
for_loop_2 = memoize('for_loop_2', for_loop_2);


let for_loop_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'for_loop',
    sub_rule_index: 3, type: 'for_loop', named,
  };

  if (stream[i].type !== 'for') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['key'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['value'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'of') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['of'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_7 = exp(stream, i);
  if (!_rule_7) return false;
  named['exp'] = _rule_7;
  children.push(_rule_7);
  i = _rule_7.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 9,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_10 = SCOPED_STATEMENTS(stream, i);
  while (_rule_10) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_10);
    children.push(_rule_10);
    i = _rule_10.last_index;
    _rule_10 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'for_loop', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 11,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
for_loop_3 = memoize('for_loop_3', for_loop_3);


function for_loop(stream, index) {
  return for_loop_0(stream, index)
    || for_loop_1(stream, index)
    || for_loop_2(stream, index)
    || for_loop_3(stream, index);
}
let func_def_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def',
    sub_rule_index: 0, type: 'func_def', named,
  };
  if (stream[i].type === 'async') {
    named['async'] = stream[i];
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== 'def') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'name') {
    named['name'] = stream[i];
    children.push(stream[i]); i++;
  }
  const _rule_3 = generic_params(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    named['generic_params'] = _rule_3;
    i = _rule_3.last_index;
  }

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = annotation(stream, i);
  if (_rule_6) {
    children.push(_rule_6);
    named['annotation'] = _rule_6;
    i = _rule_6.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_8 = func_body(stream, i);
  if (!_rule_8) return false;
  named['body'] = _rule_8;
  children.push(_rule_8);
  i = _rule_8.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_0 = memoize('func_def_0', func_def_0);


let func_def_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def',
    sub_rule_index: 1, type: 'func_def', named,
  };
  if (stream[i].type === 'async') {
    named['async'] = stream[i];
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== 'def') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'name') {
    named['name'] = stream[i];
    children.push(stream[i]); i++;
  }
  const _rule_3 = generic_params(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    named['generic_params'] = _rule_3;
    i = _rule_3.last_index;
  }

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = func_def_params(stream, i);
  if (!_rule_5) return false;
  named['params'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_7 = annotation(stream, i);
  if (_rule_7) {
    children.push(_rule_7);
    named['annotation'] = _rule_7;
    i = _rule_7.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_9 = func_body(stream, i);
  if (!_rule_9) return false;
  named['body'] = _rule_9;
  children.push(_rule_9);
  i = _rule_9.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_1 = memoize('func_def_1', func_def_1);


let func_def_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def',
    sub_rule_index: 2, type: 'func_def', named,
  };
  if (stream[i].type === 'async') {
    named['async'] = stream[i];
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = func_def_params(stream, i);
  if (!_rule_2) return false;
  named['params'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = annotation(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    named['annotation'] = _rule_4;
    i = _rule_4.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['fat-arrow'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_8 = func_body_fat(stream, i);
  if (!_rule_8) return false;
  named['body'] = _rule_8;
  children.push(_rule_8);
  i = _rule_8.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_2 = memoize('func_def_2', func_def_2);


let func_def_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def',
    sub_rule_index: 3, type: 'func_def', named,
  };
  if (stream[i].type === 'async') {
    named['async'] = stream[i];
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = annotation(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    named['annotation'] = _rule_3;
    i = _rule_3.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['fat-arrow'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_7 = func_body_fat(stream, i);
  if (!_rule_7) return false;
  named['body'] = _rule_7;
  children.push(_rule_7);
  i = _rule_7.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_3 = memoize('func_def_3', func_def_3);


function func_def(stream, index) {
  return func_def_0(stream, index)
    || func_def_1(stream, index)
    || func_def_2(stream, index)
    || func_def_3(stream, index);
}
let generic_params_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'generic_params',
    sub_rule_index: 0, type: 'generic_params', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = generic_param_list(stream, i);
  if (!_rule_1) return false;
  named['params'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
generic_params_0 = memoize('generic_params_0', generic_params_0);


function generic_params(stream, index) {
  return generic_params_0(stream, index);
}
let generic_param_list_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'generic_param_list',
    sub_rule_index: 0, type: 'generic_param_list', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['param'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'extends') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_expression(stream, i);
  if (!_rule_3) return false;
  named['constraint'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = generic_param_list(stream, i);
  if (!_rule_6) return false;
  named['rest'] = _rule_6;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
generic_param_list_0 = memoize('generic_param_list_0', generic_param_list_0);


let generic_param_list_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'generic_param_list',
    sub_rule_index: 1, type: 'generic_param_list', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['param'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'extends') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_expression(stream, i);
  if (!_rule_3) return false;
  named['constraint'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
generic_param_list_1 = memoize('generic_param_list_1', generic_param_list_1);


let generic_param_list_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'generic_param_list',
    sub_rule_index: 2, type: 'generic_param_list', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['param'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = generic_param_list(stream, i);
  if (!_rule_3) return false;
  named['rest'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
generic_param_list_2 = memoize('generic_param_list_2', generic_param_list_2);


let generic_param_list_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'generic_param_list',
    sub_rule_index: 3, type: 'generic_param_list', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'generic_param_list', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['param'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
generic_param_list_3 = memoize('generic_param_list_3', generic_param_list_3);


function generic_param_list(stream, index) {
  return generic_param_list_0(stream, index)
    || generic_param_list_1(stream, index)
    || generic_param_list_2(stream, index)
    || generic_param_list_3(stream, index);
}
let type_arguments_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_arguments',
    sub_rule_index: 0, type: 'type_arguments', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_arguments', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = type_argument_list(stream, i);
  if (!_rule_1) return false;
  named['args'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_arguments', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_arguments_0 = memoize('type_arguments_0', type_arguments_0);


function type_arguments(stream, index) {
  return type_arguments_0(stream, index);
}
let type_argument_list_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_argument_list',
    sub_rule_index: 0, type: 'type_argument_list', named,
  };
  const _rule_0 = type_expression(stream, i);
  if (!_rule_0) return false;
  named['arg'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_argument_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_argument_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_argument_list(stream, i);
  if (!_rule_3) return false;
  named['rest'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_argument_list_0 = memoize('type_argument_list_0', type_argument_list_0);


let type_argument_list_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_argument_list',
    sub_rule_index: 1, type: 'type_argument_list', named,
  };
  const _rule_0 = type_expression(stream, i);
  if (!_rule_0) return false;
  named['arg'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_argument_list_1 = memoize('type_argument_list_1', type_argument_list_1);


function type_argument_list(stream, index) {
  return type_argument_list_0(stream, index)
    || type_argument_list_1(stream, index);
}
let annotation_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'annotation',
    sub_rule_index: 0, type: 'annotation', named,
  };

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['predicate_param'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'is') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = type_expression(stream, i);
  if (!_rule_5) return false;
  named['predicate_type'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
annotation_0 = memoize('annotation_0', annotation_0);


let annotation_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'annotation',
    sub_rule_index: 1, type: 'annotation', named,
  };

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'annotation', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = type_expression(stream, i);
  if (!_rule_2) return false;
  named['type'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
annotation_1 = memoize('annotation_1', annotation_1);


function annotation(stream, index) {
  return annotation_0(stream, index)
    || annotation_1(stream, index);
}
let type_expression_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_expression',
    sub_rule_index: 0, type: 'type_expression', named,
  };
  const _rule_0 = type_primary(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'pipe') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = type_expression(stream, i);
  if (!_rule_4) return false;
  named['union'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_expression_0 = memoize('type_expression_0', type_expression_0);


let type_expression_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_expression',
    sub_rule_index: 1, type: 'type_expression', named,
  };
  const _rule_0 = type_primary(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'ampersand') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = type_expression(stream, i);
  if (!_rule_4) return false;
  named['intersection'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_expression_1 = memoize('type_expression_1', type_expression_1);


let type_expression_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_expression',
    sub_rule_index: 2, type: 'type_expression', named,
  };
  const _rule_0 = type_primary(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_expression_2 = memoize('type_expression_2', type_expression_2);


function type_expression(stream, index) {
  return type_expression_0(stream, index)
    || type_expression_1(stream, index)
    || type_expression_2(stream, index);
}
let type_primary_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 0, type: 'type_primary', named,
  };

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = func_type_params(stream, i);
  if (!_rule_1) return false;
  named['params'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = type_expression(stream, i);
  if (!_rule_6) return false;
  named['return'] = _rule_6;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_0 = memoize('type_primary_0', type_primary_0);


let type_primary_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 1, type: 'type_primary', named,
  };

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = type_expression(stream, i);
  if (!_rule_5) return false;
  named['return'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_1 = memoize('type_primary_1', type_primary_1);


let type_primary_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 2, type: 'type_primary', named,
  };

  if (stream[i].type !== 'keyof') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = type_primary(stream, i);
  if (!_rule_1) return false;
  named['subject'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  const _rule_2 = array_suffix(stream, i);
  if (_rule_2) {
    children.push(_rule_2);
    i = _rule_2.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_2 = memoize('type_primary_2', type_primary_2);


let type_primary_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 3, type: 'type_primary', named,
  };
  const _rule_0 = tuple_type(stream, i);
  if (!_rule_0) return false;
  named['tuple'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = array_suffix(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_3 = memoize('type_primary_3', type_primary_3);


let type_primary_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 4, type: 'type_primary', named,
  };
  const _rule_0 = object_type(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = array_suffix(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_4 = memoize('type_primary_4', type_primary_4);


let type_primary_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 5, type: 'type_primary', named,
  };

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['literal'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = array_suffix(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_5 = memoize('type_primary_5', type_primary_5);


let type_primary_6 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 6, type: 'type_primary', named,
  };

  if (stream[i].type !== 'number') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['literal'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = array_suffix(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_6 = memoize('type_primary_6', type_primary_6);


let type_primary_7 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 7, type: 'type_primary', named,
  };
  const _rule_0 = type_name(stream, i);
  if (!_rule_0) return false;
  named['name'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 7,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = type_arg_list(stream, i);
  if (!_rule_2) return false;
  named['type_args'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 7,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = array_suffix(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    i = _rule_4.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_7 = memoize('type_primary_7', type_primary_7);


let type_primary_8 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 8, type: 'type_primary', named,
  };
  const _rule_0 = type_name(stream, i);
  if (!_rule_0) return false;
  named['name'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 8,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = type_arg_list(stream, i);
  if (!_rule_2) return false;
  named['type_args'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 8,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_8 = memoize('type_primary_8', type_primary_8);


let type_primary_9 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 9, type: 'type_primary', named,
  };
  const _rule_0 = type_name(stream, i);
  if (!_rule_0) return false;
  named['name'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== '.') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 9,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 9,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['member'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_3 = array_suffix(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    i = _rule_3.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_9 = memoize('type_primary_9', type_primary_9);


let type_primary_10 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 10, type: 'type_primary', named,
  };
  const _rule_0 = type_name(stream, i);
  if (!_rule_0) return false;
  named['name'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 10,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 10,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['member_key'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_primary', sub_rule_index: 10,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = array_suffix(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    i = _rule_4.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_10 = memoize('type_primary_10', type_primary_10);


let type_primary_11 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_primary',
    sub_rule_index: 11, type: 'type_primary', named,
  };
  const _rule_0 = type_name(stream, i);
  if (!_rule_0) return false;
  named['name'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = array_suffix(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_primary_11 = memoize('type_primary_11', type_primary_11);


function type_primary(stream, index) {
  return type_primary_0(stream, index)
    || type_primary_1(stream, index)
    || type_primary_2(stream, index)
    || type_primary_3(stream, index)
    || type_primary_4(stream, index)
    || type_primary_5(stream, index)
    || type_primary_6(stream, index)
    || type_primary_7(stream, index)
    || type_primary_8(stream, index)
    || type_primary_9(stream, index)
    || type_primary_10(stream, index)
    || type_primary_11(stream, index);
}
let func_type_params_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_type_params',
    sub_rule_index: 0, type: 'func_type_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_expression(stream, i);
  if (!_rule_3) return false;
  named['type'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = func_type_params(stream, i);
  if (!_rule_6) return false;
  named['rest'] = _rule_6;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_type_params_0 = memoize('func_type_params_0', func_type_params_0);


let func_type_params_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_type_params',
    sub_rule_index: 1, type: 'func_type_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_type_params', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_expression(stream, i);
  if (!_rule_3) return false;
  named['type'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_type_params_1 = memoize('func_type_params_1', func_type_params_1);


function func_type_params(stream, index) {
  return func_type_params_0(stream, index)
    || func_type_params_1(stream, index);
}
let array_suffix_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'array_suffix',
    sub_rule_index: 0, type: 'array_suffix', named,
  };

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_suffix', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_suffix', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = array_suffix(stream, i);
  if (_rule_2) {
    children.push(_rule_2);
    i = _rule_2.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
array_suffix_0 = memoize('array_suffix_0', array_suffix_0);


function array_suffix(stream, index) {
  return array_suffix_0(stream, index);
}
let tuple_type_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'tuple_type',
    sub_rule_index: 0, type: 'tuple_type', named,
  };

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'tuple_type', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = tuple_type_elements(stream, i);
  if (!_rule_1) return false;
  named['elements'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'tuple_type', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
tuple_type_0 = memoize('tuple_type_0', tuple_type_0);


function tuple_type(stream, index) {
  return tuple_type_0(stream, index);
}
let tuple_type_elements_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'tuple_type_elements',
    sub_rule_index: 0, type: 'tuple_type_elements', named,
  };
  const _rule_0 = type_expression(stream, i);
  if (!_rule_0) return false;
  named['element'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'tuple_type_elements', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'tuple_type_elements', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = tuple_type_elements(stream, i);
  if (!_rule_3) return false;
  named['rest'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
tuple_type_elements_0 = memoize('tuple_type_elements_0', tuple_type_elements_0);


let tuple_type_elements_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'tuple_type_elements',
    sub_rule_index: 1, type: 'tuple_type_elements', named,
  };
  const _rule_0 = type_expression(stream, i);
  if (!_rule_0) return false;
  named['element'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
tuple_type_elements_1 = memoize('tuple_type_elements_1', tuple_type_elements_1);


function tuple_type_elements(stream, index) {
  return tuple_type_elements_0(stream, index)
    || tuple_type_elements_1(stream, index);
}
let type_arg_list_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_arg_list',
    sub_rule_index: 0, type: 'type_arg_list', named,
  };
  const _rule_0 = type_expression(stream, i);
  if (!_rule_0) return false;
  named['arg'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_arg_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_arg_list', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_arg_list(stream, i);
  if (!_rule_3) return false;
  named['rest'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_arg_list_0 = memoize('type_arg_list_0', type_arg_list_0);


let type_arg_list_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_arg_list',
    sub_rule_index: 1, type: 'type_arg_list', named,
  };
  const _rule_0 = type_expression(stream, i);
  if (!_rule_0) return false;
  named['arg'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_arg_list_1 = memoize('type_arg_list_1', type_arg_list_1);


function type_arg_list(stream, index) {
  return type_arg_list_0(stream, index)
    || type_arg_list_1(stream, index);
}
let object_type_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type',
    sub_rule_index: 0, type: 'object_type', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = wcomment(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_5 = object_type_properties(stream, i);
  if (!_rule_5) return false;
  named['properties'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  const _rule_6 = single_space_or_newline(stream, i);
  if (!_rule_6) return false;
  children.push(_rule_6);
  i = _rule_6.last_index;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_0 = memoize('object_type_0', object_type_0);


let object_type_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type',
    sub_rule_index: 1, type: 'object_type', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = single_space_or_newline(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  const _rule_2 = object_type_properties(stream, i);
  if (!_rule_2) return false;
  named['properties'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_1 = memoize('object_type_1', object_type_1);


let object_type_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type',
    sub_rule_index: 2, type: 'object_type', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_2 = memoize('object_type_2', object_type_2);


function object_type(stream, index) {
  return object_type_0(stream, index)
    || object_type_1(stream, index)
    || object_type_2(stream, index);
}
let object_type_properties_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type_properties',
    sub_rule_index: 0, type: 'object_type_properties', named,
  };
  const _rule_0 = object_type_property(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_properties', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = single_space_or_newline(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = object_type_properties(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_properties_0 = memoize('object_type_properties_0', object_type_properties_0);


let object_type_properties_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type_properties',
    sub_rule_index: 1, type: 'object_type_properties', named,
  };
  const _rule_0 = object_type_property(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_properties', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_properties_1 = memoize('object_type_properties_1', object_type_properties_1);


let object_type_properties_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type_properties',
    sub_rule_index: 2, type: 'object_type_properties', named,
  };
  const _rule_0 = object_type_property(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_properties_2 = memoize('object_type_properties_2', object_type_properties_2);


function object_type_properties(stream, index) {
  return object_type_properties_0(stream, index)
    || object_type_properties_1(stream, index)
    || object_type_properties_2(stream, index);
}
let object_type_property_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type_property',
    sub_rule_index: 0, type: 'object_type_property', named,
  };

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['keyName'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  const _rule_4 = type_expression(stream, i);
  if (!_rule_4) return false;
  named['keyType'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  const _rule_8 = type_expression(stream, i);
  if (!_rule_8) return false;
  named['valueType'] = _rule_8;
  children.push(_rule_8);
  i = _rule_8.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_property_0 = memoize('object_type_property_0', object_type_property_0);


let object_type_property_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type_property',
    sub_rule_index: 1, type: 'object_type_property', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['key'] = stream[i];
  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== 'question') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['optional'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  const _rule_5 = type_expression(stream, i);
  if (!_rule_5) return false;
  named['valueType'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_property_1 = memoize('object_type_property_1', object_type_property_1);


let object_type_property_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_type_property',
    sub_rule_index: 2, type: 'object_type_property', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['key'] = stream[i];
  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_type_property', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  const _rule_4 = type_expression(stream, i);
  if (!_rule_4) return false;
  named['valueType'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_type_property_2 = memoize('object_type_property_2', object_type_property_2);


function object_type_property(stream, index) {
  return object_type_property_0(stream, index)
    || object_type_property_1(stream, index)
    || object_type_property_2(stream, index);
}
let type_name_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_name',
    sub_rule_index: 0, type: 'type_name', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_name', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_name_0 = memoize('type_name_0', type_name_0);


let type_name_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_name',
    sub_rule_index: 1, type: 'type_name', named,
  };

  if (stream[i].type !== 'null') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_name', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_name_1 = memoize('type_name_1', type_name_1);


let type_name_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_name',
    sub_rule_index: 2, type: 'type_name', named,
  };

  if (stream[i].type !== 'undefined') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_name', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_name_2 = memoize('type_name_2', type_name_2);


let type_name_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_name',
    sub_rule_index: 3, type: 'type_name', named,
  };

  if (stream[i].type !== 'true') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_name', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_name_3 = memoize('type_name_3', type_name_3);


let type_name_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_name',
    sub_rule_index: 4, type: 'type_name', named,
  };

  if (stream[i].type !== 'false') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_name', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_name_4 = memoize('type_name_4', type_name_4);


function type_name(stream, index) {
  return type_name_0(stream, index)
    || type_name_1(stream, index)
    || type_name_2(stream, index)
    || type_name_3(stream, index)
    || type_name_4(stream, index);
}
let func_def_params_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def_params',
    sub_rule_index: 0, type: 'func_def_params', named,
  };
  const _rule_0 = object_destructuring(stream, i);
  if (!_rule_0) return false;
  named['destructuring'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = func_def_params(stream, i);
  if (!_rule_4) return false;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_params_0 = memoize('func_def_params_0', func_def_params_0);


let func_def_params_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def_params',
    sub_rule_index: 1, type: 'func_def_params', named,
  };
  const _rule_0 = object_destructuring(stream, i);
  if (!_rule_0) return false;
  named['destructuring'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_params_1 = memoize('func_def_params_1', func_def_params_1);


let func_def_params_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def_params',
    sub_rule_index: 2, type: 'func_def_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = single_space_or_newline(stream, i);
  if (!_rule_5) return false;
  children.push(_rule_5);
  i = _rule_5.last_index;
  const _rule_6 = func_def_params(stream, i);
  if (!_rule_6) return false;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_params_2 = memoize('func_def_params_2', func_def_params_2);


let func_def_params_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def_params',
    sub_rule_index: 3, type: 'func_def_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_params_3 = memoize('func_def_params_3', func_def_params_3);


let func_def_params_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def_params',
    sub_rule_index: 4, type: 'func_def_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = func_def_params(stream, i);
  if (!_rule_4) return false;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_params_4 = memoize('func_def_params_4', func_def_params_4);


let func_def_params_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_def_params',
    sub_rule_index: 5, type: 'func_def_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_def_params', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    named['annotation'] = _rule_1;
    i = _rule_1.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_def_params_5 = memoize('func_def_params_5', func_def_params_5);


function func_def_params(stream, index) {
  return func_def_params_0(stream, index)
    || func_def_params_1(stream, index)
    || func_def_params_2(stream, index)
    || func_def_params_3(stream, index)
    || func_def_params_4(stream, index)
    || func_def_params_5(stream, index);
}
let func_call_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_call',
    sub_rule_index: 0, type: 'func_call', named,
  };

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = newline_and_space(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  const _rule_2 = func_call_params(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_call_0 = memoize('func_call_0', func_call_0);


let func_call_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_call',
    sub_rule_index: 1, type: 'func_call', named,
  };

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_call_1 = memoize('func_call_1', func_call_1);


function func_call(stream, index) {
  return func_call_0(stream, index)
    || func_call_1(stream, index);
}
let func_call_params_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_call_params',
    sub_rule_index: 0, type: 'func_call_params', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call_params', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = exp(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_call_params_0 = memoize('func_call_params_0', func_call_params_0);


let func_call_params_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_call_params',
    sub_rule_index: 1, type: 'func_call_params', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_call_params', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = single_space_or_newline(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = func_call_params(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_call_params_1 = memoize('func_call_params_1', func_call_params_1);


let func_call_params_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_call_params',
    sub_rule_index: 2, type: 'func_call_params', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_call_params_2 = memoize('func_call_params_2', func_call_params_2);


function func_call_params(stream, index) {
  return func_call_params_0(stream, index)
    || func_call_params_1(stream, index)
    || func_call_params_2(stream, index);
}
let func_body_fat_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_body_fat',
    sub_rule_index: 0, type: 'func_body_fat', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_body_fat', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = wcomment(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  let _rule_2 = SCOPED_STATEMENTS(stream, i);
  while (_rule_2) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_body_fat', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_body_fat_0 = memoize('func_body_fat_0', func_body_fat_0);


let func_body_fat_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_body_fat',
    sub_rule_index: 1, type: 'func_body_fat', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['exp'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_body_fat_1 = memoize('func_body_fat_1', func_body_fat_1);


function func_body_fat(stream, index) {
  return func_body_fat_0(stream, index)
    || func_body_fat_1(stream, index);
}
let func_body_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'func_body',
    sub_rule_index: 0, type: 'func_body', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_body', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = wcomment(stream, i);
  if (_rule_1) {
    children.push(_rule_1);
    i = _rule_1.last_index;
  }
  let _rule_2 = SCOPED_STATEMENTS(stream, i);
  while (_rule_2) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'func_body', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
func_body_0 = memoize('func_body_0', func_body_0);


function func_body(stream, index) {
  return func_body_0(stream, index);
}
let class_def_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'class_def',
    sub_rule_index: 0, type: 'class_def', named,
  };

  if (stream[i].type !== 'clazz') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'extends') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['extends'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_7 = wcomment(stream, i);
  if (_rule_7) {
    children.push(_rule_7);
    i = _rule_7.last_index;
  }
  let _rule_8 = CLASS_STATEMENT(stream, i);
  while (_rule_8) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_8);
    children.push(_rule_8);
    i = _rule_8.last_index;
    _rule_8 = CLASS_STATEMENT(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 9,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
class_def_0 = memoize('class_def_0', class_def_0);


let class_def_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'class_def',
    sub_rule_index: 1, type: 'class_def', named,
  };

  if (stream[i].type !== 'clazz') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = wcomment(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    i = _rule_4.last_index;
  }
  let _rule_5 = CLASS_STATEMENT(stream, i);
  while (_rule_5) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_5);
    children.push(_rule_5);
    i = _rule_5.last_index;
    _rule_5 = CLASS_STATEMENT(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
class_def_1 = memoize('class_def_1', class_def_1);


function class_def(stream, index) {
  return class_def_0(stream, index)
    || class_def_1(stream, index);
}
let class_func_def_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'class_func_def',
    sub_rule_index: 0, type: 'class_func_def', named,
  };
  if (stream[i].type === 'async') {
    named['async'] = stream[i];
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== 'def') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'name') {
    named['name'] = stream[i];
    children.push(stream[i]); i++;
  }
  const _rule_3 = generic_params(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    named['generic_params'] = _rule_3;
    i = _rule_3.last_index;
  }

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = annotation(stream, i);
  if (_rule_6) {
    children.push(_rule_6);
    named['annotation'] = _rule_6;
    i = _rule_6.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_8 = func_body(stream, i);
  if (!_rule_8) return false;
  named['body'] = _rule_8;
  children.push(_rule_8);
  i = _rule_8.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
class_func_def_0 = memoize('class_func_def_0', class_func_def_0);


let class_func_def_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'class_func_def',
    sub_rule_index: 1, type: 'class_func_def', named,
  };
  if (stream[i].type === 'async') {
    named['async'] = stream[i];
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== 'def') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'name') {
    named['name'] = stream[i];
    children.push(stream[i]); i++;
  }
  const _rule_3 = generic_params(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    named['generic_params'] = _rule_3;
    i = _rule_3.last_index;
  }

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = func_def_params(stream, i);
  if (!_rule_5) return false;
  named['params'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_7 = annotation(stream, i);
  if (_rule_7) {
    children.push(_rule_7);
    named['annotation'] = _rule_7;
    i = _rule_7.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_func_def', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_9 = func_body(stream, i);
  if (!_rule_9) return false;
  named['body'] = _rule_9;
  children.push(_rule_9);
  i = _rule_9.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
class_func_def_1 = memoize('class_func_def_1', class_func_def_1);


function class_func_def(stream, index) {
  return class_func_def_0(stream, index)
    || class_func_def_1(stream, index);
}
let class_member_def_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'class_member_def',
    sub_rule_index: 0, type: 'class_member_def', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'class_member_def', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (!_rule_1) return false;
  named['annotation'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
class_member_def_0 = memoize('class_member_def_0', class_member_def_0);


function class_member_def(stream, index) {
  return class_member_def_0(stream, index);
}
let CLASS_STATEMENT_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'CLASS_STATEMENT',
    sub_rule_index: 0, type: 'CLASS_STATEMENT', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'CLASS_STATEMENT', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_3 = class_func_def(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = wcomment(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    i = _rule_4.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
CLASS_STATEMENT_0 = memoize('CLASS_STATEMENT_0', CLASS_STATEMENT_0);


let CLASS_STATEMENT_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'CLASS_STATEMENT',
    sub_rule_index: 1, type: 'CLASS_STATEMENT', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'CLASS_STATEMENT', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_3 = class_member_def(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = wcomment(stream, i);
  if (_rule_4) {
    children.push(_rule_4);
    i = _rule_4.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
CLASS_STATEMENT_1 = memoize('CLASS_STATEMENT_1', CLASS_STATEMENT_1);


let CLASS_STATEMENT_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'CLASS_STATEMENT',
    sub_rule_index: 2, type: 'CLASS_STATEMENT', named,
  };

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'CLASS_STATEMENT', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_3 = scomment(stream, i);
  if (_rule_3) {
    children.push(_rule_3);
    i = _rule_3.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
CLASS_STATEMENT_2 = memoize('CLASS_STATEMENT_2', CLASS_STATEMENT_2);


function CLASS_STATEMENT(stream, index) {
  return CLASS_STATEMENT_0(stream, index)
    || CLASS_STATEMENT_1(stream, index)
    || CLASS_STATEMENT_2(stream, index);
}
let array_literal_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'array_literal',
    sub_rule_index: 0, type: 'array_literal', named,
  };

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_literal', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'newline') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  const _rule_3 = array_literal_body(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  if (stream[i].type === 'newline') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_literal', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
array_literal_0 = memoize('array_literal_0', array_literal_0);


let array_literal_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'array_literal',
    sub_rule_index: 1, type: 'array_literal', named,
  };

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_literal', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_literal', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
array_literal_1 = memoize('array_literal_1', array_literal_1);


function array_literal(stream, index) {
  return array_literal_0(stream, index)
    || array_literal_1(stream, index);
}
let array_literal_body_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'array_literal_body',
    sub_rule_index: 0, type: 'array_literal_body', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'array_literal_body', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = single_space_or_newline(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = array_literal_body(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
array_literal_body_0 = memoize('array_literal_body_0', array_literal_body_0);


let array_literal_body_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'array_literal_body',
    sub_rule_index: 1, type: 'array_literal_body', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
array_literal_body_1 = memoize('array_literal_body_1', array_literal_body_1);


function array_literal_body(stream, index) {
  return array_literal_body_0(stream, index)
    || array_literal_body_1(stream, index);
}
let condition_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'condition',
    sub_rule_index: 0, type: 'condition', named,
  };

  if (stream[i].type !== 'if') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'condition', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['type'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['exp'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'condition', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'condition', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_4 = SCOPED_STATEMENTS(stream, i);
  while (_rule_4) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_4);
    children.push(_rule_4);
    i = _rule_4.last_index;
    _rule_4 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'condition', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = else_if(stream, i);
  if (_rule_6) {
    children.push(_rule_6);
    named['elseif'] = _rule_6;
    i = _rule_6.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
condition_0 = memoize('condition_0', condition_0);


function condition(stream, index) {
  return condition_0(stream, index);
}
let else_if_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'else_if',
    sub_rule_index: 0, type: 'else_if', named,
  };

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'elseif') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['type'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_2 = exp(stream, i);
  if (!_rule_2) return false;
  named['exp'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_5 = SCOPED_STATEMENTS(stream, i);
  while (_rule_5) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_5);
    children.push(_rule_5);
    i = _rule_5.last_index;
    _rule_5 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_7 = else_if(stream, i);
  if (!_rule_7) return false;
  named['elseif'] = _rule_7;
  children.push(_rule_7);
  i = _rule_7.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
else_if_0 = memoize('else_if_0', else_if_0);


let else_if_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'else_if',
    sub_rule_index: 1, type: 'else_if', named,
  };

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'elseif') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['type'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_2 = exp(stream, i);
  if (!_rule_2) return false;
  named['exp'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_5 = SCOPED_STATEMENTS(stream, i);
  while (_rule_5) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_5);
    children.push(_rule_5);
    i = _rule_5.last_index;
    _rule_5 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
else_if_1 = memoize('else_if_1', else_if_1);


let else_if_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'else_if',
    sub_rule_index: 2, type: 'else_if', named,
  };

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'else') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['type'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_3 = SCOPED_STATEMENTS(stream, i);
  while (_rule_3) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_3);
    children.push(_rule_3);
    i = _rule_3.last_index;
    _rule_3 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'else_if', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
else_if_2 = memoize('else_if_2', else_if_2);


let else_if_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'else_if',
    sub_rule_index: 3, type: 'else_if', named,
  };
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
else_if_3 = memoize('else_if_3', else_if_3);


function else_if(stream, index) {
  return else_if_0(stream, index)
    || else_if_1(stream, index)
    || else_if_2(stream, index)
    || else_if_3(stream, index);
}
let while_loop_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'while_loop',
    sub_rule_index: 0, type: 'while_loop', named,
  };

  if (stream[i].type !== 'while') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'while_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['exp'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'while_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'while_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_4 = SCOPED_STATEMENTS(stream, i);
  while (_rule_4) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_4);
    children.push(_rule_4);
    i = _rule_4.last_index;
    _rule_4 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'while_loop', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
while_loop_0 = memoize('while_loop_0', while_loop_0);


function while_loop(stream, index) {
  return while_loop_0(stream, index);
}
let object_literal_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal',
    sub_rule_index: 0, type: 'object_literal', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = single_space_or_newline(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  const _rule_2 = object_literal_body(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_0 = memoize('object_literal_0', object_literal_0);


let object_literal_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal',
    sub_rule_index: 1, type: 'object_literal', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_1 = memoize('object_literal_1', object_literal_1);


function object_literal(stream, index) {
  return object_literal_0(stream, index)
    || object_literal_1(stream, index);
}
let single_space_or_newline_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'single_space_or_newline',
    sub_rule_index: 0, type: 'single_space_or_newline', named,
  };
  const _rule_0 = wcomment(stream, i);
  if (_rule_0) {
    children.push(_rule_0);
    i = _rule_0.last_index;
  }

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'single_space_or_newline', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
single_space_or_newline_0 = memoize('single_space_or_newline_0', single_space_or_newline_0);


let single_space_or_newline_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'single_space_or_newline',
    sub_rule_index: 1, type: 'single_space_or_newline', named,
  };

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'single_space_or_newline', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
single_space_or_newline_1 = memoize('single_space_or_newline_1', single_space_or_newline_1);


function single_space_or_newline(stream, index) {
  return single_space_or_newline_0(stream, index)
    || single_space_or_newline_1(stream, index);
}
let newline_and_space_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'newline_and_space',
    sub_rule_index: 0, type: 'newline_and_space', named,
  };
  const _rule_0 = wcomment(stream, i);
  if (_rule_0) {
    children.push(_rule_0);
    i = _rule_0.last_index;
  }

  if (stream[i].type !== 'newline') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'newline_and_space', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }
  if (stream[i].type === 'W') {
    children.push(stream[i]); i++;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
newline_and_space_0 = memoize('newline_and_space_0', newline_and_space_0);


function newline_and_space(stream, index) {
  return newline_and_space_0(stream, index);
}
let object_literal_body_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_body',
    sub_rule_index: 0, type: 'object_literal_body', named,
  };

  if (stream[i].type !== 'spread') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['spread'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['spread_exp'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = object_literal_body(stream, i);
  if (!_rule_4) return false;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_body_0 = memoize('object_literal_body_0', object_literal_body_0);


let object_literal_body_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_body',
    sub_rule_index: 1, type: 'object_literal_body', named,
  };

  if (stream[i].type !== 'spread') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['spread'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['spread_exp'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_body_1 = memoize('object_literal_body_1', object_literal_body_1);


let object_literal_body_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_body',
    sub_rule_index: 2, type: 'object_literal_body', named,
  };
  const _rule_0 = object_literal_key(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = single_space_or_newline(stream, i);
  if (!_rule_5) return false;
  children.push(_rule_5);
  i = _rule_5.last_index;
  const _rule_6 = object_literal_body(stream, i);
  if (!_rule_6) return false;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_body_2 = memoize('object_literal_body_2', object_literal_body_2);


let object_literal_body_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_body',
    sub_rule_index: 3, type: 'object_literal_body', named,
  };
  const _rule_0 = object_literal_key(stream, i);
  if (!_rule_0) return false;
  named['key'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = single_space_or_newline(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = object_literal_body(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_body_3 = memoize('object_literal_body_3', object_literal_body_3);


let object_literal_body_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_body',
    sub_rule_index: 4, type: 'object_literal_body', named,
  };
  const _rule_0 = object_literal_key(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_body', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_body_4 = memoize('object_literal_body_4', object_literal_body_4);


let object_literal_body_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_body',
    sub_rule_index: 5, type: 'object_literal_body', named,
  };
  const _rule_0 = object_literal_key(stream, i);
  if (!_rule_0) return false;
  named['key'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_body_5 = memoize('object_literal_body_5', object_literal_body_5);


function object_literal_body(stream, index) {
  return object_literal_body_0(stream, index)
    || object_literal_body_1(stream, index)
    || object_literal_body_2(stream, index)
    || object_literal_body_3(stream, index)
    || object_literal_body_4(stream, index)
    || object_literal_body_5(stream, index);
}
let object_destructuring_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_destructuring',
    sub_rule_index: 0, type: 'object_destructuring', named,
  };

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_destructuring', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_destructuring', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = destructuring_values(stream, i);
  if (!_rule_2) return false;
  named['values'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_destructuring', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_destructuring_0 = memoize('object_destructuring_0', object_destructuring_0);


function object_destructuring(stream, index) {
  return object_destructuring_0(stream, index);
}
let destructuring_values_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 0, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = object_destructuring(stream, i);
  if (!_rule_3) return false;
  named['nested'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = single_space_or_newline(stream, i);
  if (!_rule_5) return false;
  children.push(_rule_5);
  i = _rule_5.last_index;
  const _rule_6 = destructuring_values(stream, i);
  if (!_rule_6) return false;
  named['more'] = _rule_6;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_0 = memoize('destructuring_values_0', destructuring_values_0);


let destructuring_values_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 1, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'colon') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = object_destructuring(stream, i);
  if (!_rule_3) return false;
  named['nested'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_1 = memoize('destructuring_values_1', destructuring_values_1);


let destructuring_values_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 2, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (!_rule_1) return false;
  named['annotation'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = single_space_or_newline(stream, i);
  if (!_rule_3) return false;
  children.push(_rule_3);
  i = _rule_3.last_index;
  const _rule_4 = destructuring_values(stream, i);
  if (!_rule_4) return false;
  named['more'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_2 = memoize('destructuring_values_2', destructuring_values_2);


let destructuring_values_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 3, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = annotation(stream, i);
  if (!_rule_1) return false;
  named['annotation'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_3 = memoize('destructuring_values_3', destructuring_values_3);


let destructuring_values_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 4, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 4,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = single_space_or_newline(stream, i);
  if (!_rule_2) return false;
  children.push(_rule_2);
  i = _rule_2.last_index;
  const _rule_3 = destructuring_values(stream, i);
  if (!_rule_3) return false;
  named['more'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_4 = memoize('destructuring_values_4', destructuring_values_4);


let destructuring_values_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 5, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'as') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['rename'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ',') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = single_space_or_newline(stream, i);
  if (!_rule_5) return false;
  children.push(_rule_5);
  i = _rule_5.last_index;
  const _rule_6 = destructuring_values(stream, i);
  if (!_rule_6) return false;
  named['more'] = _rule_6;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_5 = memoize('destructuring_values_5', destructuring_values_5);


let destructuring_values_6 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 6, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'as') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['rename'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_6 = memoize('destructuring_values_6', destructuring_values_6);


let destructuring_values_7 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'destructuring_values',
    sub_rule_index: 7, type: 'destructuring_values', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'destructuring_values', sub_rule_index: 7,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
destructuring_values_7 = memoize('destructuring_values_7', destructuring_values_7);


function destructuring_values(stream, index) {
  return destructuring_values_0(stream, index)
    || destructuring_values_1(stream, index)
    || destructuring_values_2(stream, index)
    || destructuring_values_3(stream, index)
    || destructuring_values_4(stream, index)
    || destructuring_values_5(stream, index)
    || destructuring_values_6(stream, index)
    || destructuring_values_7(stream, index);
}
let import_statement_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'import_statement',
    sub_rule_index: 0, type: 'import_statement', named,
  };

  if (stream[i].type !== 'import') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'from') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['file'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
import_statement_0 = memoize('import_statement_0', import_statement_0);


let import_statement_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'import_statement',
    sub_rule_index: 1, type: 'import_statement', named,
  };

  if (stream[i].type !== 'import') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = destructuring_values(stream, i);
  if (!_rule_3) return false;
  named['dest_values'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'from') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['file'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
import_statement_1 = memoize('import_statement_1', import_statement_1);


let import_statement_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'import_statement',
    sub_rule_index: 2, type: 'import_statement', named,
  };

  if (stream[i].type !== 'import') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['module'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'as') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
import_statement_2 = memoize('import_statement_2', import_statement_2);


let import_statement_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'import_statement',
    sub_rule_index: 3, type: 'import_statement', named,
  };

  if (stream[i].type !== 'import') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'import_statement', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['file'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
import_statement_3 = memoize('import_statement_3', import_statement_3);


function import_statement(stream, index) {
  return import_statement_0(stream, index)
    || import_statement_1(stream, index)
    || import_statement_2(stream, index)
    || import_statement_3(stream, index);
}
let type_alias_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'type_alias',
    sub_rule_index: 0, type: 'type_alias', named,
  };

  if (stream[i].type !== 'type') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_alias', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_alias', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_2 = generic_params(stream, i);
  if (_rule_2) {
    children.push(_rule_2);
    named['generic_params'] = _rule_2;
    i = _rule_2.last_index;
  }

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_alias', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_alias', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'type_alias', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_6 = type_expression(stream, i);
  if (!_rule_6) return false;
  named['type'] = _rule_6;
  children.push(_rule_6);
  i = _rule_6.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
type_alias_0 = memoize('type_alias_0', type_alias_0);


function type_alias(stream, index) {
  return type_alias_0(stream, index);
}
let object_literal_key_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_key',
    sub_rule_index: 0, type: 'object_literal_key', named,
  };

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_key', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_key_0 = memoize('object_literal_key_0', object_literal_key_0);


let object_literal_key_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'object_literal_key',
    sub_rule_index: 1, type: 'object_literal_key', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'object_literal_key', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
object_literal_key_1 = memoize('object_literal_key_1', object_literal_key_1);


function object_literal_key(stream, index) {
  return object_literal_key_0(stream, index)
    || object_literal_key_1(stream, index);
}
let virtual_node_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node',
    sub_rule_index: 0, type: 'virtual_node', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['opening'] = stream[i];
  children.push(stream[i]); i++;
  let _rule_2 = virtual_node_attributes(stream, i);
  while (_rule_2) {
    named['attrs'] ? null : named['attrs'] = [];
    named['attrs'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = virtual_node_attributes(stream, i);
  }
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== '/>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_0 = memoize('virtual_node_0', virtual_node_0);


let virtual_node_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node',
    sub_rule_index: 1, type: 'virtual_node', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['opening'] = stream[i];
  children.push(stream[i]); i++;
  let _rule_2 = virtual_node_attributes(stream, i);
  while (_rule_2) {
    named['attrs'] ? null : named['attrs'] = [];
    named['attrs'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = virtual_node_attributes(stream, i);
  }

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_4 = SCOPED_STATEMENTS(stream, i);
  while (_rule_4) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_4);
    children.push(_rule_4);
    i = _rule_4.last_index;
    _rule_4 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '</') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['closing'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (!(node => node.named.opening.value === node.named.closing.value)(node)) { return false; }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_1 = memoize('virtual_node_1', virtual_node_1);


let virtual_node_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node',
    sub_rule_index: 2, type: 'virtual_node', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['opening'] = stream[i];
  children.push(stream[i]); i++;
  let _rule_2 = virtual_node_attributes(stream, i);
  while (_rule_2) {
    named['attrs'] ? null : named['attrs'] = [];
    named['attrs'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = virtual_node_attributes(stream, i);
  }

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['exp'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;

  if (stream[i].type !== '</') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['closing'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (!(node => node.named.opening.value === node.named.closing.value)(node)) { return false; }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_2 = memoize('virtual_node_2', virtual_node_2);


function virtual_node(stream, index) {
  return virtual_node_0(stream, index)
    || virtual_node_1(stream, index)
    || virtual_node_2(stream, index);
}
let virtual_node_exp_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_exp',
    sub_rule_index: 0, type: 'virtual_node_exp', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['opening'] = stream[i];
  children.push(stream[i]); i++;
  let _rule_2 = virtual_node_attributes(stream, i);
  while (_rule_2) {
    named['attrs'] ? null : named['attrs'] = [];
    named['attrs'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = virtual_node_attributes(stream, i);
  }
  if (stream[i].type === 'w') {
    children.push(stream[i]); i++;
  }

  if (stream[i].type !== '/>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_exp_0 = memoize('virtual_node_exp_0', virtual_node_exp_0);


let virtual_node_exp_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_exp',
    sub_rule_index: 1, type: 'virtual_node_exp', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['opening'] = stream[i];
  children.push(stream[i]); i++;
  let _rule_2 = virtual_node_attributes(stream, i);
  while (_rule_2) {
    named['attrs'] ? null : named['attrs'] = [];
    named['attrs'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = virtual_node_attributes(stream, i);
  }

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_4 = SCOPED_STATEMENTS(stream, i);
  while (_rule_4) {
    named['stats'] ? null : named['stats'] = [];
    named['stats'].push(_rule_4);
    children.push(_rule_4);
    i = _rule_4.last_index;
    _rule_4 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '</') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['closing'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (!(node => node.named.opening.value === node.named.closing.value)(node)) { return false; }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_exp_1 = memoize('virtual_node_exp_1', virtual_node_exp_1);


let virtual_node_exp_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_exp',
    sub_rule_index: 2, type: 'virtual_node_exp', named,
  };

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['opening'] = stream[i];
  children.push(stream[i]); i++;
  let _rule_2 = virtual_node_attributes(stream, i);
  while (_rule_2) {
    named['attrs'] ? null : named['attrs'] = [];
    named['attrs'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = virtual_node_attributes(stream, i);
  }

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['exp'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;

  if (stream[i].type !== '</') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['closing'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  if (!(node => node.named.opening.value === node.named.closing.value)(node)) { return false; }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_exp_2 = memoize('virtual_node_exp_2', virtual_node_exp_2);


function virtual_node_exp(stream, index) {
  return virtual_node_exp_0(stream, index)
    || virtual_node_exp_1(stream, index)
    || virtual_node_exp_2(stream, index);
}
let virtual_node_assign_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_assign',
    sub_rule_index: 0, type: 'virtual_node_assign', named,
  };

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_assign', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_assign', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = exp(stream, i);
  if (!_rule_2) return false;
  named['exp'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_assign_0 = memoize('virtual_node_assign_0', virtual_node_assign_0);


function virtual_node_assign(stream, index) {
  return virtual_node_assign_0(stream, index);
}
let virtual_node_attributes_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_attributes',
    sub_rule_index: 0, type: 'virtual_node_attributes', named,
  };
  const _rule_0 = single_space_or_newline(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'attribute_name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_attributes', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_attributes', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  named['exp'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_attributes_0 = memoize('virtual_node_attributes_0', virtual_node_attributes_0);


let virtual_node_attributes_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_attributes',
    sub_rule_index: 1, type: 'virtual_node_attributes', named,
  };
  const _rule_0 = single_space_or_newline(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'attribute_name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_attributes', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_attributes_1 = memoize('virtual_node_attributes_1', virtual_node_attributes_1);


let virtual_node_attributes_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_attributes',
    sub_rule_index: 2, type: 'virtual_node_attributes', named,
  };
  const _rule_0 = single_space_or_newline(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_attributes', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '=') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_attributes', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  named['exp'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_attributes_2 = memoize('virtual_node_attributes_2', virtual_node_attributes_2);


let virtual_node_attributes_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'virtual_node_attributes',
    sub_rule_index: 3, type: 'virtual_node_attributes', named,
  };
  const _rule_0 = single_space_or_newline(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'virtual_node_attributes', sub_rule_index: 3,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
virtual_node_attributes_3 = memoize('virtual_node_attributes_3', virtual_node_attributes_3);


function virtual_node_attributes(stream, index) {
  return virtual_node_attributes_0(stream, index)
    || virtual_node_attributes_1(stream, index)
    || virtual_node_attributes_2(stream, index)
    || virtual_node_attributes_3(stream, index);
}
let str_expression_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'str_expression',
    sub_rule_index: 0, type: 'str_expression', named,
  };

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'str_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['str'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = inner_str_expression(stream, i);
  if (!_rule_1) return false;
  named['str_exp'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
str_expression_0 = memoize('str_expression_0', str_expression_0);


let str_expression_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'str_expression',
    sub_rule_index: 1, type: 'str_expression', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'str_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'str_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['str'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_2 = inner_str_expression(stream, i);
  if (_rule_2) {
    children.push(_rule_2);
    named['str_exp'] = _rule_2;
    i = _rule_2.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};
str_expression_1 = memoize('str_expression_1', str_expression_1);


function str_expression(stream, index) {
  return str_expression_0(stream, index)
    || str_expression_1(stream, index);
}
let inner_str_expression_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'inner_str_expression',
    sub_rule_index: 0, type: 'inner_str_expression', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['exp'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'inner_str_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['str'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_2 = inner_str_expression(stream, i);
  if (!_rule_2) return false;
  named['str_exp'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
inner_str_expression_0 = memoize('inner_str_expression_0', inner_str_expression_0);


let inner_str_expression_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'inner_str_expression',
    sub_rule_index: 1, type: 'inner_str_expression', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['exp'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'inner_str_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['str'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
inner_str_expression_1 = memoize('inner_str_expression_1', inner_str_expression_1);


let inner_str_expression_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'inner_str_expression',
    sub_rule_index: 2, type: 'inner_str_expression', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['exp'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
inner_str_expression_2 = memoize('inner_str_expression_2', inner_str_expression_2);


function inner_str_expression(stream, index) {
  return inner_str_expression_0(stream, index)
    || inner_str_expression_1(stream, index)
    || inner_str_expression_2(stream, index);
}
let try_catch_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'try_catch',
    sub_rule_index: 0, type: 'try_catch', named,
  };

  if (stream[i].type !== 'try') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['try'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_2 = SCOPED_STATEMENTS(stream, i);
  while (_rule_2) {
    named['statstry'] ? null : named['statstry'] = [];
    named['statstry'].push(_rule_2);
    children.push(_rule_2);
    i = _rule_2.last_index;
    _rule_2 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'catch') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 5,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['catch'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '{') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 8,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  let _rule_9 = SCOPED_STATEMENTS(stream, i);
  while (_rule_9) {
    named['statscatch'] ? null : named['statscatch'] = [];
    named['statscatch'].push(_rule_9);
    children.push(_rule_9);
    i = _rule_9.last_index;
    _rule_9 = SCOPED_STATEMENTS(stream, i);
  }

  if (stream[i].type !== '}') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'try_catch', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 10,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
try_catch_0 = memoize('try_catch_0', try_catch_0);


function try_catch(stream, index) {
  return try_catch_0(stream, index);
}
let name_exp_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'name_exp',
    sub_rule_index: 0, type: 'name_exp', named,
  };

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'name_exp', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['name'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
name_exp_0 = memoize('name_exp_0', name_exp_0);


function name_exp(stream, index) {
  return name_exp_0(stream, index);
}
let short_if_expression_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'short_if_expression',
    sub_rule_index: 0, type: 'short_if_expression', named,
  };

  if (stream[i].type !== 'if') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['type'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['exp1'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = exp(stream, i);
  if (!_rule_5) return false;
  named['exp2'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 6,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'else') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 7,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['else'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_8 = exp(stream, i);
  if (!_rule_8) return false;
  named['exp3'] = _rule_8;
  children.push(_rule_8);
  i = _rule_8.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
short_if_expression_0 = memoize('short_if_expression_0', short_if_expression_0);


let short_if_expression_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'short_if_expression',
    sub_rule_index: 1, type: 'short_if_expression', named,
  };

  if (stream[i].type !== 'if') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['type'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['exp1'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '=>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'short_if_expression', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_5 = exp(stream, i);
  if (!_rule_5) return false;
  named['exp2'] = _rule_5;
  children.push(_rule_5);
  i = _rule_5.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
short_if_expression_1 = memoize('short_if_expression_1', short_if_expression_1);


function short_if_expression(stream, index) {
  return short_if_expression_0(stream, index)
    || short_if_expression_1(stream, index);
}
let new_expression_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'new_expression',
    sub_rule_index: 0, type: 'new_expression', named,
  };

  if (stream[i].type !== 'new') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'new_expression', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  named['exp'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
new_expression_0 = memoize('new_expression_0', new_expression_0);


function new_expression(stream, index) {
  return new_expression_0(stream, index);
}
let dynamic_import_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'dynamic_import',
    sub_rule_index: 0, type: 'dynamic_import', named,
  };

  if (stream[i].type !== 'import_call') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'dynamic_import', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'dynamic_import', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['file'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'dynamic_import', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};
dynamic_import_0 = memoize('dynamic_import_0', dynamic_import_0);


function dynamic_import(stream, index) {
  return dynamic_import_0(stream, index);
}
let exp_0 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 0, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['obj'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'optional_chain') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['optional'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 0,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['prop'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_1 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 1, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['obj'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== '.') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'name') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 1,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['prop'] = stream[i];
  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_2 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 2, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['obj'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'optional_chain') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['optional'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = exp(stream, i);
  if (!_rule_3) return false;
  named['key'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 2,
        sub_rule_stream_index: i - index, sub_rule_token_index: 4,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_3 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 3, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['obj'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = type_arguments(stream, i);
  if (!_rule_1) return false;
  named['type_args'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  const _rule_2 = func_call(stream, i);
  if (!_rule_2) return false;
  named['call'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_4 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 4, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['obj'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;
  const _rule_1 = func_call(stream, i);
  if (!_rule_1) return false;
  named['call'] = _rule_1;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_5 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 5, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['obj'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== '[') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_2 = exp(stream, i);
  if (!_rule_2) return false;
  named['key'] = _rule_2;
  children.push(_rule_2);
  i = _rule_2.last_index;

  if (stream[i].type !== ']') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 5,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_6 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 6, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['left'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'nullish') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['nullish_op'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 6,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['right'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_7 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 7, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['left'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 7,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'math_operator') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 7,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['math_op'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 7,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['right'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_8 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 8, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['left'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 8,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'boolean_operator') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 8,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['boolean_op'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 8,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['right'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_9 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 9, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['left'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 9,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '<') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 9,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['boolean_op'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 9,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['right'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_10 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 10, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['left'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 10,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== '>') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 10,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['boolean_op'] = stream[i];
  children.push(stream[i]); i++;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 10,
        sub_rule_stream_index: i - index, sub_rule_token_index: 3,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_4 = exp(stream, i);
  if (!_rule_4) return false;
  named['right'] = _rule_4;
  children.push(_rule_4);
  i = _rule_4.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_11 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 11, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['exp'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'w') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 11,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;

  if (stream[i].type !== 'as') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 11,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_3 = type_expression(stream, i);
  if (!_rule_3) return false;
  named['type_cast'] = _rule_3;
  children.push(_rule_3);
  i = _rule_3.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_12 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 12, type: 'exp', named,
  };
  const _rule_0 = exp(stream, i);
  if (!_rule_0) return false;
  named['left'] = _rule_0;
  children.push(_rule_0);
  i = _rule_0.last_index;

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 12,
        sub_rule_stream_index: i - index, sub_rule_token_index: 1,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['str'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_2 = inner_str_expression(stream, i);
  if (_rule_2) {
    children.push(_rule_2);
    named['str_exp'] = _rule_2;
    i = _rule_2.last_index;
  }
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_13 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 13, type: 'exp', named,
  };
  const _rule_0 = str_expression(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_14 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 14, type: 'exp', named,
  };
  const _rule_0 = name_exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_15 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 15, type: 'exp', named,
  };
  const _rule_0 = func_def(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_16 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 16, type: 'exp', named,
  };

  if (stream[i].type !== 'number') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 16,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_17 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 17, type: 'exp', named,
  };

  if (stream[i].type !== 'null') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 17,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_18 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 18, type: 'exp', named,
  };

  if (stream[i].type !== 'undefined') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 18,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_19 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 19, type: 'exp', named,
  };

  if (stream[i].type !== 'true') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 19,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_20 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 20, type: 'exp', named,
  };

  if (stream[i].type !== 'false') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 20,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_21 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 21, type: 'exp', named,
  };

  if (stream[i].type !== 'str') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 21,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_22 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 22, type: 'exp', named,
  };

  if (stream[i].type !== 'regexp') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 22,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_23 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 23, type: 'exp', named,
  };

  if (stream[i].type !== '(') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 23,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;

  if (stream[i].type !== ')') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 23,
        sub_rule_stream_index: i - index, sub_rule_token_index: 2,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_24 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 24, type: 'exp', named,
  };

  if (stream[i].type !== 'operand') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 24,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_25 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 25, type: 'exp', named,
  };

  if (stream[i].type !== 'unary') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 25,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_26 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 26, type: 'exp', named,
  };

  if (stream[i].type !== 'math_operator') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 26,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  named['math_op'] = stream[i];
  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_27 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 27, type: 'exp', named,
  };
  const _rule_0 = object_literal(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_28 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 28, type: 'exp', named,
  };
  const _rule_0 = array_literal(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_29 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 29, type: 'exp', named,
  };

  if (stream[i].type !== 'await') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 29,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_30 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 30, type: 'exp', named,
  };
  const _rule_0 = virtual_node_assign(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_31 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 31, type: 'exp', named,
  };
  const _rule_0 = virtual_node_exp(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_32 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 32, type: 'exp', named,
  };
  const _rule_0 = new_expression(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_33 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 33, type: 'exp', named,
  };
  const _rule_0 = dynamic_import(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_34 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 34, type: 'exp', named,
  };

  if (stream[i].type !== 'delete') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 34,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_35 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 35, type: 'exp', named,
  };

  if (stream[i].type !== 'spread') {
    if (i >= best_failure_index) {
      const failure = {
        type: 'exp', sub_rule_index: 35,
        sub_rule_stream_index: i - index, sub_rule_token_index: 0,
        stream_index: i, token: stream[i], first_token: stream[index], success: false,
      };
      record_failure(failure, i);
    }
    return false;
  }

  children.push(stream[i]); i++;
  const _rule_1 = exp(stream, i);
  if (!_rule_1) return false;
  children.push(_rule_1);
  i = _rule_1.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp_36 = (stream, index) => {
  let i = index;
  const children = [];
  const named = {};
  const node = {
    children, stream_index: index, name: 'exp',
    sub_rule_index: 36, type: 'exp', named,
  };
  const _rule_0 = short_if_expression(stream, i);
  if (!_rule_0) return false;
  children.push(_rule_0);
  i = _rule_0.last_index;
  node.success = i === stream.length; node.last_index = i;
  return node;
};


let exp = memoize_left_recur('exp', function exp_combined(stream, index) {
  return exp_0(stream, index)
    || exp_1(stream, index)
    || exp_2(stream, index)
    || exp_3(stream, index)
    || exp_4(stream, index)
    || exp_5(stream, index)
    || exp_6(stream, index)
    || exp_7(stream, index)
    || exp_8(stream, index)
    || exp_9(stream, index)
    || exp_10(stream, index)
    || exp_11(stream, index)
    || exp_12(stream, index)
    || exp_13(stream, index)
    || exp_14(stream, index)
    || exp_15(stream, index)
    || exp_16(stream, index)
    || exp_17(stream, index)
    || exp_18(stream, index)
    || exp_19(stream, index)
    || exp_20(stream, index)
    || exp_21(stream, index)
    || exp_22(stream, index)
    || exp_23(stream, index)
    || exp_24(stream, index)
    || exp_25(stream, index)
    || exp_26(stream, index)
    || exp_27(stream, index)
    || exp_28(stream, index)
    || exp_29(stream, index)
    || exp_30(stream, index)
    || exp_31(stream, index)
    || exp_32(stream, index)
    || exp_33(stream, index)
    || exp_34(stream, index)
    || exp_35(stream, index)
    || exp_36(stream, index);
});
function _tokenize(tokenDef, input, char, stream) {
  let match;
  match = input.substring(char).match(tokenDef.number.reg);
  if (match !== null) {
    return [match[0], 'number'];
  }
  match = input.substring(char).match(tokenDef.null.reg);
  if (match !== null) {
    return [match[0], 'null'];
  }
  match = input.substring(char).match(tokenDef.undefined.reg);
  if (match !== null) {
    return [match[0], 'undefined'];
  }
  match = input.substring(char).match(tokenDef.true.reg);
  if (match !== null) {
    return [match[0], 'true'];
  }
  match = input.substring(char).match(tokenDef.false.reg);
  if (match !== null) {
    return [match[0], 'false'];
  }
  if (input.substr(char, 5) === 'type ') {
    return ['type ', 'type'];
  }
  match = input.substring(char).match(tokenDef.comment.reg);
  if (match !== null) {
    return [match[0], 'comment'];
  }
  match = input.substring(char).match(tokenDef.multiline_comment.reg);
  if (match !== null) {
    return [match[0], 'multiline_comment'];
  }
  if (input.substr(char, 3) === 'as ') {
    return ['as ', 'as'];
  }
  if (input.substr(char, 3) === 'is ') {
    return ['is ', 'is'];
  }
  if (input.substr(char, 6) === 'keyof ') {
    return ['keyof ', 'keyof'];
  }
  if (input.substr(char, 6) === 'class ') {
    return ['class ', 'clazz'];
  }
  if (input.substr(char, 4) === 'try ') {
    return ['try ', 'try'];
  }
  if (input.substr(char, 6) === 'catch ') {
    return ['catch ', 'catch'];
  }
  if (input.substr(char, 4) === 'def ') {
    return ['def ', 'def'];
  }
  if (input.substr(char, 4) === 'new ') {
    return ['new ', 'new'];
  }
  if (input.substr(char, 7) === 'delete ') {
    return ['delete ', 'delete'];
  }
  if (input.substr(char, 3) === 'if ') {
    return ['if ', 'if'];
  }
  if (input.substr(char, 6) === 'while ') {
    return ['while ', 'while'];
  }
  if (input.substr(char, 5) === 'else ') {
    return ['else ', 'else'];
  }
  if (input.substr(char, 4) === 'for ') {
    return ['for ', 'for'];
  }
  if (input.substr(char, 3) === 'in ') {
    return ['in ', 'in'];
  }
  if (input.substr(char, 3) === 'of ') {
    return ['of ', 'of'];
  }
  if (input.substr(char, 6) === 'await ') {
    return ['await ', 'await'];
  }
  if (input.substr(char, 6) === 'async ') {
    return ['async ', 'async'];
  }
  if (input.substr(char, 8) === 'extends ') {
    return ['extends ', 'extends'];
  }
  if (input.substr(char, 7) === 'elseif ') {
    return ['elseif ', 'elseif'];
  }
  match = tokenDef.return.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'return'];
  }
  match = tokenDef.break.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'break'];
  }
  match = tokenDef.continue.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'continue'];
  }
  if (input.substr(char, 6) === 'throw ') {
    return ['throw ', 'throw'];
  }
  if (input.substr(char, 7) === 'import(') {
    return ['import(', 'import_call'];
  }
  if (input.substr(char, 7) === 'import ') {
    return ['import ', 'import'];
  }
  if (input.substr(char, 3) === '...') {
    return ['...', 'spread'];
  }
  if (input.substr(char, 5) === 'from ') {
    return ['from ', 'from'];
  }
  match = input.substring(char).match(tokenDef.operand.reg);
  if (match !== null) {
    return [match[0], 'operand'];
  }
  if (input.substr(char, 1) === ',') {
    return [',', ','];
  }
  if (input.substr(char, 2) === '??') {
    return ['??', 'nullish'];
  }
  if (input.substr(char, 2) === '?.') {
    return ['?.', 'optional_chain'];
  }
  match = input.substring(char).match(tokenDef.boolean_operator.reg);
  if (match !== null) {
    return [match[0], 'boolean_operator'];
  }
  if (input.substr(char, 1) === '.') {
    return ['.', '.'];
  }
  match = tokenDef.pipe.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'pipe'];
  }
  match = tokenDef.ampersand.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'ampersand'];
  }
  if (input.substr(char, 1) === '(') {
    return ['(', '('];
  }
  if (input.substr(char, 1) === ')') {
    return [')', ')'];
  }
  if (input.substr(char, 1) === '{') {
    return ['{', '{'];
  }
  if (input.substr(char, 1) === '}') {
    return ['}', '}'];
  }
  if (input.substr(char, 2) === '</') {
    return ['</', '</'];
  }
  if (input.substr(char, 2) === '/>') {
    return ['/>', '/>'];
  }
  if (input.substr(char, 1) === '[') {
    return ['[', '['];
  }
  if (input.substr(char, 1) === ']') {
    return [']', ']'];
  }
  if (input.substr(char, 2) === '=>') {
    return ['=>', '=>'];
  }
  if (input.substr(char, 1) === '?') {
    return ['?', 'question'];
  }
  if (input.substr(char, 1) === '>') {
    return ['>', '>'];
  }
  if (input.substr(char, 1) === '<') {
    return ['<', '<'];
  }
  match = input.substring(char).match(tokenDef.attribute_name.reg);
  if (match !== null) {
    return [match[0], 'attribute_name'];
  }
  match = input.substring(char).match(tokenDef.name.reg);
  if (match !== null) {
    return [match[0], 'name'];
  }
  match = tokenDef.regexp.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'regexp'];
  }
  match = input.substring(char).match(tokenDef.assign_operator.reg);
  if (match !== null) {
    return [match[0], 'assign_operator'];
  }
  match = input.substring(char).match(tokenDef.math_operator.reg);
  if (match !== null) {
    return [match[0], 'math_operator'];
  }
  if (input.substr(char, 1) === '!') {
    return ['!', 'unary'];
  }
  if (input.substr(char, 2) === ':=') {
    return [':=', 'explicit_assign'];
  }
  if (input.substr(char, 1) === '=') {
    return ['=', '='];
  }
  if (input.substr(char, 1) === ':') {
    return [':', 'colon'];
  }
  if (input.substr(char, 1) === `
`) {
    return [`
`, 'newline'];
  }
  match = tokenDef.str.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'str'];
  }
  match = tokenDef.w.func(input.substring(char), stream);
  if (match !== undefined) {
    return [match, 'w'];
  }
  match = input.substring(char).match(tokenDef.W.reg);
  if (match !== null) {
    return [match[0], 'W'];
  }
  return [null, 'W'];
}
function tokenize(tokenDef, input) {
  const stream = [];
  const originalInput = input;
  let lastToken;
  let key;
  let candidate = null;
  const len = input.length;
  let char = 0;
  let index = 0;
  let line = 0;
  let column = 0;
  while (char < len) {
    [candidate, key] = _tokenize(tokenDef, originalInput, char, stream);
    if (candidate !== null) {
      const candidateLen = candidate.length;
      lastToken = {
        type: key,
        value: candidate,
        start: char,
        stream_index: index,
        len: candidateLen,
        line_start: line,
        column_start: column,
      };
      // Only split if there might be newlines (optimization)
      if (candidate.indexOf('\n') !== -1) {
        const lines = candidate.split('\n');
        line += lines.length - 1;
        column = lines[lines.length - 1].length;
      } else {
        column += candidateLen;
      }
      lastToken.lineEnd = line;
      lastToken.columnEnd = column;
      stream.push(lastToken);
      index++;
      char += candidateLen;
    } else {
      if (stream.length === 0) {
        throw new Error('Tokenizer error: total match failure');
      }
      if (lastToken) {
        lastToken.pointer += lastToken.len;
      }
      let msg = `Tokenizer error, no matching token found for ${originalInput.slice(char, char + 26)}`;
      if (lastToken) {
        msg += ` After token of type ${lastToken.type}: ${lastToken.value}`;
      }
      const error = new Error(msg);
      error.token = lastToken;
      throw error;
    }
  }
  stream.push({
    type: 'EOS', value: '<End Of Stream>', char, index,
  });
  return stream;
}


const parse = (stream) => {
  best_failure = null;
  best_failure_index = 0;
  best_failure_array = [];
  cache = {};
  cacheR = {};
  const result = START(stream, 0);
  if (!result) {
    return {
      success: false,
      primary_failure: best_failure,
      all_failures: best_failure_array,
    }
  }
  return result;
}

export default {
  parse,
  tokenize,
};
